<template>
	<v-card
			class="mx-auto"
			max-width="450"
		>
			<v-toolbar
				color="secondary"
				flat
			>
				<v-toolbar-title>
					No.{{ score['number'] }}
				</v-toolbar-title>	
			</v-toolbar>

			<v-card-title>
				<ScoreTitle
					:title="score['title']"
					:scoreURL="score['page-url']"
					:name="score['source']"
				/>
			</v-card-title>
			
			<v-card-subtitle>
				<ScoreArtist
					:artist="score['artist']"
					:artistURL="score['artist-url']"
				/>
			</v-card-subtitle>

			<v-divider/>

			<v-card-subtitle>
				<label>Difficulty</label>
			</v-card-subtitle>
			<v-card-text>
				<ScoreDifficulty :diffArray="score['difficult']"></ScoreDifficulty>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					icon
					@click="show = !show"
				>
					<v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
				</v-btn>
			</v-card-actions>

			<v-expand-transition>
				<div v-show="show">
					<v-divider></v-divider>
					<v-card-subtitle>
						詳細情報
					</v-card-subtitle>
					<v-card-text>
						<div>
							曲の長さ: {{score['length']}}
						</div>
						<div>
							BPM: {{score['bpm']}}
						</div>
						<div v-if="score['original-source']">
							原曲: {{score['original-source']}}
						</div>
					</v-card-text>
				</div>
			</v-expand-transition>

		</v-card>
</template>

<script>
import ScoreTitle from './ScoreTitle.vue';
import ScoreArtist from './ScoreArtist.vue';
import ScoreDifficulty from './ScoreDifficulty.vue';

export default {
	props: {
		score: {
			type: Object,
		}
	},
	data: () => {
		return {
			show: false,
		}
	},
	components: {
		ScoreTitle,
		ScoreArtist,
		ScoreDifficulty,
	},
	computed: {
		headerColor() {
			// 7key譜面があるかの確認
			const key7 = this.score['difficult'].filter(elem => {
				return elem['key'] === '7key';
			});

			// 在るならヘッダーを緑に
			if(key7.length > 0) {
				return 'green lighten-3';
				} else {
					// 無いなら赤に
				return 'red lighten-3';
			}
		},
	},

}
</script>

<style>

</style>